<div
  class="flex flex-row flex-nowrap min-w-fit items-center pr-4 gap-2"
  [class.cursor-wait]="loading()"
>
  @if (icon()) {
    <soft-icon [name]="icon()" class="mx-2 scale-150"></soft-icon>
  }
  <div class="flex flex-col w-full">
    <span class="font-semibold" [ngClass]="titleClass()">{{ title() }}</span>
    <span
      [class.soft-link]="!readonly()"
      [ngClass]="valueClass()"
      (click)="!readonly() && onClick.emit()"
    >
      @if (loading()) {
        <div class="skeleton h-4 w-full cursor-wait select-none rounded-sm">&nbsp;</div>
      } @else {
        {{ value() }}
      }
    </span>
  </div>
</div>
